// Claude: buyerSubscriptionSlice.ts — Redux slice for buyer subscription plan admin 11-Apr-2026
// Claude: added minAssuredResponses, pricePerRFX, currency 20-04-2026
// Claude: closedMeetingsLimit removed 23-04-2026
// Claude: store numeric fields as strings so backspace works; parse only at submit 23-04-2026
// Claude: pricePerRFX → subscriptionFee; setBuyerPricePerRFX → setSubscriptionFee 25-Apr-2026
import { createSlice } from "@reduxjs/toolkit";

const buyerSubscriptionSlice = createSlice({
  name: "buyerSubscription",

  initialState: {
    subscriptions: [] as any[],
    planName: '',
    rfxLimit: '0',
    pendingMeetingsLimit: '0',
    minAssuredResponses: '0',
    subscriptionFee: '0',
    currency: 'USD',
    rfpResponsePendingLimit: '3',
    isActive: false,
  },

  reducers: {
    setBuyerSubscriptions: (state, action) => {
      state.subscriptions = action.payload;
    },
    setBuyerPlanName: (state, action) => {
      state.planName = action.payload;
    },
    setBuyerRfxLimit: (state, action) => {
      state.rfxLimit = action.payload;
    },
    setBuyerPendingMeetingsLimit: (state, action) => {
      state.pendingMeetingsLimit = action.payload;
    },
    setBuyerRfpResponsePendingLimit: (state, action) => {
      state.rfpResponsePendingLimit = action.payload;
    },
    setBuyerMinAssuredResponses: (state, action) => {
      state.minAssuredResponses = action.payload;
    },
    setSubscriptionFee: (state, action) => {
      state.subscriptionFee = action.payload;
    },
    setBuyerCurrency: (state, action) => {
      state.currency = action.payload;
    },
    setBuyerIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    resetBuyerForm: (state) => {
      state.planName = '';
      state.rfxLimit = '0';
      state.pendingMeetingsLimit = '0';
      state.minAssuredResponses = '0';
      state.subscriptionFee = '0';
      state.currency = 'USD';
      state.rfpResponsePendingLimit = '3';
      state.isActive = false;
    },
  },
});

export const {
  setBuyerSubscriptions,
  setBuyerPlanName,
  setBuyerRfxLimit,
  setBuyerPendingMeetingsLimit,
  setBuyerRfpResponsePendingLimit,
  setBuyerMinAssuredResponses,
  setSubscriptionFee,
  setBuyerCurrency,
  setBuyerIsActive,
  resetBuyerForm,
} = buyerSubscriptionSlice.actions;

export const buyerSubscriptionReducer = buyerSubscriptionSlice.reducer;
